import { render, staticRenderFns } from "./PanelDerecho.vue?vue&type=template&id=aeebddfe&scoped=true&"
import script from "./PanelDerecho.vue?vue&type=script&lang=js&"
export * from "./PanelDerecho.vue?vue&type=script&lang=js&"
import style0 from "./PanelDerecho.vue?vue&type=style&index=0&id=aeebddfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeebddfe",
  null
  
)

export default component.exports